<script setup lang="ts">
  import { Skeleton } from '@rapoo/element'

  const gearSlots = [0, 1, 2, 3, 4, 5, 6, 7]
</script>

<template>
  <div class="flex w-full items-center justify-center gap-2" aria-busy="true">
    <div class="flex h-67.5 w-83 flex-col gap-4 rounded-8xl glass-frosted py-4">
      <div class="flex h-6 items-center px-4">
        <Skeleton class="h-6 w-16 rounded-full" animation-type="shimmer" />
      </div>
      <div class="grid grid-cols-3 gap-2 px-4">
        <Skeleton
          v-for="slot in gearSlots"
          :key="slot"
          class="h-10 rounded-full"
          animation-type="shimmer"
        />
      </div>
    </div>

    <div class="flex h-67.5 w-250 flex-col rounded-8xl glass-frosted p-4">
      <Skeleton class="h-6 w-16 rounded-full" animation-type="shimmer" />
      <div class="flex flex-1 mt-16.5">
        <Skeleton class="h-8 w-full rounded-full" animation-type="shimmer" />
      </div>
    </div>
  </div>
</template>
